import { GridRenderCellParams } from '@mui/x-data-grid';

import TableCellTypography from 'shared/components/widgets/tabel-cell-typography';
import { bytesToSize } from 'shared/helpers/bytes-to-size';
import TooltipWithTableCellTypography from '../../../shared/components/widgets/tooltip';

export const customerDeliveryFilesListColumns = [
  {
    field: 'otmSeq',
    headerName: 'No',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 70,
    minWidth: 70,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {params?.row?.id || params?.row?.id === 0 ? params?.row?.id : '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'otmSubject',
    headerName: '업로드 제목', // Upload Title
    headerAlign: 'left',
    align: 'left',
    flex: 2,
    maxWidth: 300,
    minWidth: 300,
    renderCell: (params: GridRenderCellParams) => {
      return <TooltipWithTableCellTypography value={params.value} />;
    },
  },
  {
    field: 'regName',
    headerName: '게시자',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 165,
    minWidth: 165,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },

  {
    field: 'otmfOriginName',
    headerName: '파일명', // File Name
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 260,
    minWidth: 260,
    renderCell: (params: GridRenderCellParams) => {
      return <TooltipWithTableCellTypography value={params.value} />;
    },
  },
  {
    field: 'otmfSize',
    headerName: '파일크기', // File Size
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 90,
    minWidth: 90,
    sortable: false,
    sortComparator: (v1, v2) => parseInt(v1.field) - parseInt(v2.field),
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {bytesToSize(params.value) ?? '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'otmSt',
    headerName: '파일상태', // File Status
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    sortable: true,
    maxWidth: 115,
    minWidth: 115,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography
          style={{
            color:
              params.value === 'allow'
                ? 'var(--gray-800)'
                : 'var(--neutral-800)',
          }}
        >
          {params.value === 'allow' ? '다운로드 가능' : '다운로드 불가'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'expirationYmd',
    headerName: '만료일자', // Expiration Date
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 115,
    minWidth: 115,
    sortable: true,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value}</TableCellTypography>;
    },
  },
  {
    field: 'regDt',
    headerName: '등록일시', // Registration Date and Time
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 185,
    minWidth: 185,
    sortable: true,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value}</TableCellTypography>;
    },
  },
];
